module.exports = "/_next/static/images/main-visual-shopping-544a80007e2cec5533bee00f6d61a870.jpg";